import { render, staticRenderFns } from "./GeneralFormTab.vue?vue&type=template&id=8e148822&scoped=true"
import script from "./GeneralFormTab.vue?vue&type=script&lang=js"
export * from "./GeneralFormTab.vue?vue&type=script&lang=js"
import style0 from "./GeneralFormTab.vue?vue&type=style&index=0&id=8e148822&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e148822",
  null
  
)

export default component.exports